var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2412280(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.1 30",
    style: {
      enableBackground: "new 0 0 115.1 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.6,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.2619 48.7559)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.9,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 32.3548 98.7779)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,30H85.3V0.4h29.8V30z M86.5,28.9h27.5V1.5H86.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,26H88.7V4h22.5V26z M89.8,24.8H110V5.1H89.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: -6.2,
    transform: "matrix(0.4704 -0.8825 0.8825 0.4704 30.3455 66.2638)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.3083 38.0033)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H57V0.4h29.8V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,26H60.9V4h22.5V26z M62,24.8h20.2V5.1H62V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.1748 15.9913)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8761 9.6309)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,30H0V0.4h29.8V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: -6.2,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 15.1907 41.0066)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.1104 23.7489)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.8V30z M29.5,28.9H57V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,26H32.2V4h22.5V26z M33.4,24.8h20.2V5.1H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,29.6l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2 C86.8,29.5,86.6,29.6,86.4,29.6z M89.1,24L88.8,24c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2C89.5,23.9,89.3,24,89.1,24z M91.8,18.5l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.5,3.2C92.2,18.3,92,18.5,91.8,18.5z M94.4,12.9l-0.2-0.1 c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8L95,12.6C94.9,12.8,94.7,12.9,94.4,12.9z  M97.1,7.3l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1.5-3.2C98.3,3,98.6,2.9,98.9,3c0.3,0.1,0.4,0.5,0.3,0.8L97.6,7 C97.5,7.2,97.3,7.3,97.1,7.3z M99.8,1.7l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l0.3-0.6c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-0.3,0.6C100.2,1.6,100,1.7,99.8,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,29.6c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8 L113.8,29.6z M111.1,24c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2 c0.1,0.3,0,0.6-0.3,0.8L111.1,24z M108.4,18.5c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8L108.4,18.5z M105.7,12.9c-0.2,0-0.4-0.1-0.5-0.3l-1.5-3.2c-0.1-0.3,0-0.6,0.3-0.8 c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8L105.7,12.9z M103,7.3c-0.2,0-0.4-0.1-0.5-0.3L101,3.8 c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1.5,3.2c0.1,0.3,0,0.6-0.3,0.8L103,7.3z M100.4,1.7c-0.2,0-0.4-0.1-0.5-0.3 l-0.3-0.6c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l0.3,0.6c0.1,0.3,0,0.6-0.3,0.8L100.4,1.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2412280);
export default __webpack_public_path__ + "static/media/AK2_4_1228_0.2cf2f73cd339bcfe41a11551745187ef.svg";
export { ForwardRef as ReactComponent };